module.exports = __webpack_public_path__ + "assets/90RotationCCWDetailed.ae54ffae349c824e59a854d24fd8935a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/90RotationCCWDetailed.png
// module id = 450
// module chunks = 0